<template>
    <div>
        <h1 class="display-heading">Benefit Tier Setting</h1>

        <div class="card mb-3">
            <div class="card-header">Add Tier</div>
            <div class="card-body">
                <router-link :to="{
                    'name': 'tier-detail-add',
                }" class="btn btn-primary btn-primary-insv mr-2">
                    Add Tier
                </router-link>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header">Benefit Date Settings</div>
            <div class="card-body">
                <benefit-date-settings></benefit-date-settings>
            </div>
        </div>

        <div class="d-flex align-items-baseline">
            <div class="form-group mr-3 d-flex align-items-baseline">
                <label class="mr-2 font-weight-bold">Tier Name:</label>
                <input style="width: 150px" type="text" name="filterName" data-vv-as="filter tier name" data-vv-validate-on="blur"
                    v-model="filterName" v-validate="'required'"
                    :class="{
                        'form-control': true,
                        'is-invalid':  validationErrors.has('filterName')
                    }">
                <div v-show="validationErrors.has('filterName')" class="invalid-feedback">
                    {{ validationErrors.first('filterName') }}
                </div>
            </div>
            <button @click="getTiers" class="btn btn-primary">Search</button>
        </div>

        <div class="table-responsive">
            <div ref="tableSection">
                <table ref="listTable" class="table table-hover">
                    <col width="50">
                    <col>
                    <col width="200">
                    <col width="150">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Tier Name</th>
                            <th scope="col">Employee Spending Limit</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-show="tierList.length === 0">
                            <td :colspan="columnsCount" class="text-center font-italic">
                                {{isTableLoading ? "Loading Data": "No Data"}}
                            </td>
                        </tr>
                        <tr v-for="(tier, index) in tierList" :key="index">
                            <th scope="row">{{((pagination.currentPage - 1) * pagination.pageSize ) + index + 1}}</th>
                            <td>{{tier.name}}</td>
                            <td>{{tier.spendingLimit.toFixed(2)}}</td>
                            <td>
                                <router-link :to="{
                                    'name': 'tier-detail',
                                    'params': {'id': tier.tierId}
                                }">
                                View Tier
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>

            <popup-modal ref="popupUpdateCompanyType" :hasCloseButton="false" title="Alert">
                <template slot="content">
                    <p>Please set Benefit Commencement Date and Benefit Refresh Date before any action.</p>
                </template>
                <template slot="footer">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupMessage">Okay</button>
                </template>
            </popup-modal>

            <popup-modal ref="popupHasDefaultTier" :hasCloseButton="false" title="Info">
                <template slot="content">
                    <p>By default, all the existing employees are assigned to the "General Tier".</p>
                    <p>You may create and configure the new benefit tiers for your company, thereafter assign the existing employees to the newly created tiers.</p>
                </template>
                <template slot="footer">
                    <button type="button" class="btn btn-primary btn-primary-insv" @click="dismissPopupDefaultTier">Okay</button>
                </template>
            </popup-modal>
        </div>
    </div>
</template>

<script>
// import {
//     convertDateToDDMMYYYY
// } from '@/utilities';
import benefitDateSettings from '@/components/benefit-date-settings';
import pagination from '@/components/pagination';
import popupModal from '@/components/popup-modal';
export default {
    'name': 'TierList',
    'components': {
        pagination,
        benefitDateSettings,
        popupModal
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        },
        isChangeCompanyType () {
            if (this.$route.query) {
                return this.$route.query.hasOwnProperty('isChangeCompanyType');
            }
            return false;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getTiers();
            });
        }
    },
    data () {
        return {
            'columnsCount': 1,
            'isTableLoading': true,
            'filterName': '',
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'tierList': []
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });

        this.validateBenefitSettings();
        this.getTiers();
    },
    'methods': {
        getTiers () {
            this.axios.post('tier/GetTierList', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize,
                'tn': this.filterName
            }).then(({ data }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;

                this.tierList = list.map((tier) => ({
                    'name': tier.tn ? tier.tn : '-',
                    'spendingLimit': tier.esl,
                    'tierId': tier.ti
                }));

                if (this.isChangeCompanyType) {
                    const hasDefaultTier = this.tierList.find(t => t.name === 'General Tier');
                    if (hasDefaultTier) {
                        this.$refs.popupHasDefaultTier.show();
                        this.$refs.popupUpdateCompanyType.show();
                    }
                }
            });
        },
        validateBenefitSettings () {
            this.axios.get('Company/GetBenefitDateSettings').then(({
                data
            }) => {
                let companyData = data.data;

                if (companyData != null) {
                    if (!!companyData.benefitCommencementDate && !!companyData.benefitRefreshDate) {

                    } else {
                        this.$refs.popupUpdateCompanyType.show();
                    }
                }
            });
        },
        dismissPopupMessage () {
            this.$refs.popupUpdateCompanyType.hide();
        },
        dismissPopupDefaultTier () {
            this.$refs.popupHasDefaultTier.hide();
        }
    }
};

</script>

<style>

</style>
